import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import Stepper from 'src/components/Stepper';
import { WhiteContainer } from 'src/style/common';
import FakeLoginForm from 'src/pages/ManualLookup/LoginSimulator/fakeLoginForm';
import QRCodeGenerator from 'src/components/QRCodeGenerator';
import Column from 'src/frontend-common/components/Column';
import { LandingState } from 'src/pages/LoginSimulatorLanding';
import LoginSimulatorOutcome from 'src/pages/LoginSimulatorLanding/LoginSimulatorOutcome';
import LoginTableRemote from 'src/components/LoginTableRemote';
import { NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';

const LoginSimulator: React.FC<{
  frontEndAppKey: string;
  backEndAppKey: string;
  navigateTo: NavigateCallbackFn;
}> = ({ frontEndAppKey, backEndAppKey, navigateTo }) => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [userData, setUserData] = useState<{ username: string; pw: string }>({
    username: '',
    pw: '',
  });

  const [formState, setFormState] = useState<LandingState>('form');
  const [identityId, setIdentityId] = useState<string>('');

  const steps = ['Enrollment', 'Login', 'Result'];

  const resetAll = () => {
    setCurrentStep(0);
    setUserData({ username: '', pw: '' });
    setFormState('form');
    setIdentityId('');
  };

  return (
    <>
      <WhiteContainer style={{ boxShadow: 'none', padding: 24, marginTop: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Column style={{ height: '100%' }}>
              <div style={{ margin: '24px 16px' }}>
                <Stepper steps={steps} currentStep={currentStep} />
              </div>
              <>
                {formState === 'form' && (
                  <FakeLoginForm
                    setCurrentStep={setCurrentStep}
                    backEndAppKey={backEndAppKey}
                    frontEndAppKey={frontEndAppKey}
                    backButton={currentStep === 0 ? false : true}
                    username={userData.username}
                    pw={userData.pw}
                    currentStep={currentStep}
                    setUserData={setUserData}
                    setFormState={setFormState}
                    setIdentityId={setIdentityId}
                  />
                )}
                {formState !== 'form' && (
                  <LoginSimulatorOutcome
                    landingState={formState}
                    setLandingState={setFormState}
                    isNotLanding={true}
                    resetAll={resetAll}
                    setCurrentStep={setCurrentStep}
                  />
                )}
              </>
            </Column>
          </Grid>
          <Grid item xs={6}>
            {currentStep > 0 && (
              <QRCodeGenerator url={`${process.env.REACT_APP_BASE_URL}/login-simulator/${userData.username}/${userData.pw}/${frontEndAppKey}`} />
            )}
          </Grid>
        </Grid>
      </WhiteContainer>
      <div style={{ height: 24, backgroundColor: 'rgba(244, 245, 247, 100)' }} />
      {identityId && (
        <WhiteContainer style={{ marginTop: 0 }}>
          <Typography variant="h5" style={{ marginTop: 24, marginBottom: 12 }}>
            Login activity
          </Typography>
          <LoginTableRemote identityId={identityId} navigateTo={navigateTo} />
        </WhiteContainer>
      )}
    </>
  );
};

export default LoginSimulator;
